import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import KnowledgeEnrichmentGapSuggestionsAPI from '../../api/knowledgeEnrichmentGapSuggestions';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: { totalCount: 0, page: 1 },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getGapSuggestions($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  index: async ({ commit }, { agentBotId, ...params }) => {
    commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isFetching: true });
    try {
      const response = await KnowledgeEnrichmentGapSuggestionsAPI.index(
        agentBotId,
        params
      );
      commit(types.SET_KE_GAP_SUGGESTIONS, response.data.payload);
      commit(types.SET_KE_GAP_SUGGESTIONS_META, response.data.meta);
      return response.data.payload;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isFetching: false });
    }
  },

  answer: async ({ commit }, { agentBotId, id, question, answer }) => {
    commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isUpdating: true });
    try {
      const response = await KnowledgeEnrichmentGapSuggestionsAPI.answer(
        agentBotId,
        id,
        { question, answer }
      );
      commit(types.DELETE_KE_GAP_SUGGESTION, id);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isUpdating: false });
    }
  },

  dismiss: async ({ commit }, { agentBotId, id }) => {
    commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isUpdating: true });
    try {
      await KnowledgeEnrichmentGapSuggestionsAPI.dismiss(agentBotId, id);
      commit(types.DELETE_KE_GAP_SUGGESTION, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_KE_GAP_SUGGESTION_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_KE_GAP_SUGGESTION_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_KE_GAP_SUGGESTIONS]: MutationHelpers.set,
  [types.SET_KE_GAP_SUGGESTIONS_META]($state, meta) {
    $state.meta = {
      totalCount: meta.total_count,
      page: meta.page,
    };
  },
  [types.DELETE_KE_GAP_SUGGESTION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
